export default "__VITE_ASSET__CIjtJi_e__"